export enum LangKey {
  SV = "sv",
  EN = "en",
}
export type LangKeyType = LangKey | string;
export const LangKeyList = Object.values(LangKey);
